import { render, staticRenderFns } from "./soundPlay.vue?vue&type=template&id=45d3654a&scoped=true&"
import script from "./soundPlay.vue?vue&type=script&lang=js&"
export * from "./soundPlay.vue?vue&type=script&lang=js&"
import style0 from "./soundPlay.vue?vue&type=style&index=0&id=45d3654a&prod&scoped=true&lang=css&"
import style1 from "./soundPlay.vue?vue&type=style&index=1&id=45d3654a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3654a",
  null
  
)

export default component.exports